import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { Link } from 'react-router-dom';
import { Box } from '@radix-ui/themes';
import 'swiper/css';
import 'swiper/css/pagination';

import { useSelector } from 'react-redux';
import { selectDevice } from 'store/slices/common';

export const BannerSlider = ({ banners }) => {
  const deviceType = useSelector(selectDevice);
  const isMobile = deviceType === 'mobile';

  const swiperRef = useRef(null);

  const updateFocus = swiper => {
    swiper.slides.forEach(slide => {
      const link = slide.querySelector('a');
      if (link) link.setAttribute('tabIndex', '-1');
    });

    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    const activeLink = activeSlide.querySelector('a');
    if (activeLink) activeLink.setAttribute('tabIndex', '0');
  };

  const handleSwiperInit = swiper => {
    swiperRef.current = swiper;

    const container = swiper.el;

    // 키보드 접근성
    container.addEventListener('focusin', () => {
      swiperRef.current?.autoplay?.stop();
    });

    container.addEventListener('focusout', () => {
      swiperRef.current?.autoplay?.start();
    });

    // 마우스 hover 접근성
    container.addEventListener('mouseenter', () => {
      swiperRef.current?.autoplay?.stop();
    });

    container.addEventListener('mouseleave', () => {
      swiperRef.current?.autoplay?.start();
    });
  };

  return (
    <Box className="banner-slider">
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        pagination={{
          clickable: true,
          renderBullet: (index, className) => {
            return `<button class="${className}" name="${index + 1}번째 슬라이드" aria-label="${index + 1}번째 슬라이드"><span class="visually-hidden">${index + 1}번째 슬라이드</span></button>`;
          }
        }}
        loop
        slidesPerView={1}
        onSwiper={handleSwiperInit}
        onInit={updateFocus}
        onSlideChangeTransitionEnd={updateFocus}
      >
        {banners.map(banner => (
          <SwiperSlide key={banner.id}>
            <Link to={banner.to} title={banner.title} className="slim-banner">
              <img src={banner.src} alt={banner.alt} />
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default BannerSlider;
